const professionIdMap = {
  Dentistry: 1,
  Dietetics: 2,
  Medicine: 3,
  Nursing: 4,
  OccupationalTherapy: 5,
  Optometry: 6,
  Pharmacy: 7,
  Physiotherapy: 8,
  Podiatry: 9,
  Radiography: 10,
  SpeechPathology: 11,
  VeterinaryScience: 12,
};

export default professionIdMap;
